import React, { useMemo } from "react";
import BaseNode from "./BaseNode";
import type { HandleProps, NodeProps } from "./types";
import { Position } from "@xyflow/react";
import { Input } from "../ui/input";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../ui/select";
import FormField from "@/components/FormField";
import { EqualIcon } from "lucide-react";
import useNodeField from "@/hooks/useNodeField";

const OutputNode: React.FC<NodeProps> = (props) => {
  const [fieldValue, setFieldValue] = useNodeField<string>(
    props.id,
    "fieldName",
    props.data?.fieldName || props.id,
  );
  const [fieldType, setFieldType] = useNodeField<string>(
    props.id,
    "fieldType",
    props.data?.fieldType || "text",
  );
  const handles: HandleProps[] = useMemo(
    () => [
      {
        type: "target",
        position: Position.Left,
        id: "output",
      },
    ],
    [],
  );

  return (
    <BaseNode
      title="Output"
      icon={<EqualIcon size={16} />}
      handles={handles}
      {...props}
    >
      <FormField label="Field name">
        <Input
          name="field-name"
          value={fieldValue}
          onChange={(e) => setFieldValue(e.target.value)}
        />
      </FormField>
      <FormField label="Type">
        <Select value={fieldType} onValueChange={setFieldType}>
          <SelectTrigger className="w-full">
            <SelectValue placeholder="Type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="text">Text</SelectItem>
            <SelectItem value="image">Image</SelectItem>
            <SelectItem value="formatted-text">Formatted Text</SelectItem>
            <SelectItem value="audio">Audio</SelectItem>
            <SelectItem value="json">JSON</SelectItem>
            <SelectItem value="file">File</SelectItem>
          </SelectContent>
        </Select>
      </FormField>
    </BaseNode>
  );
};

export default OutputNode;
